<template>
  <div class="ai-chat">
    <div class="chat-container">
	      <div
	        v-if="isMobileHistoryOpen"
	        class="mobile-history-mask"
	        aria-hidden="true"
	        data-track-ignore
	        @click="closeMobileHistory"
	      ></div>
      <div class="chat-box">
        <div class="mobile-chat-nav">
          <button
            type="button"
            class="mobile-chat-action"
            data-track-text="开启新AI对话"
            aria-label="开启新对话"
            @click="setDefaultChat"
          >
            <i class="el-icon-plus"></i>
            新对话
          </button>
          <button
            type="button"
            class="mobile-chat-action"
            data-track-text="打开AI历史记录"
            aria-label="查看历史记录"
            :aria-expanded="String(isMobileHistoryOpen)"
            @click="openMobileHistory"
          >
            <i class="el-icon-time"></i>
            历史记录
          </button>
        </div>
        <div class="chat-list">
          <div
            class="answer-container"
            :style="{ height: isDefaultChat ? 'initial' : 'calc(100% - 40px)' }"
          >
            <el-scrollbar ref="answerScrollbarRef" class="answer-scrollbar">
              <div ref="chatListDom">
                <div
                  v-for="(item, index) of messageList.filter(
                    (v) => v.role !== 'system'
                  )"
                  :key="index"
                  :class="[item.role === 'assistant' ? 'left' : 'right']"
                  @mouseenter="selectMessage(index)"
                  @mouseleave="selectMessage()"
                >
                  <div
                    :class="[
                      'answer-item',
                      'group',
                      item.role === 'assistant' ? 'assistant' : 'user',
                      currentMessageIndex === index && item.content
                        ? 'select'
                        : '',
                    ]"
                  >
                    <div
                      :class="[
                        'answer-avatar',
                        item.role === 'assistant' ? 'ai-avatar' : 'user-avatar',
                      ]"
                    >
                      <span v-if="item.role === 'user'" class="user"></span>
                    </div>
                    <div v-if="item.role === 'user'" class="user-answer">
                      {{ item.content }}
                    </div>
                    <div v-else>
                      <div
                        class="prose"
                        v-if="item.content"
                        v-html="markdownRender.render(item.content)"
                      ></div>
                      <Loding v-else />
                    </div>
                    <div class="action" v-if="index !== 0">
                      <span
	                        v-if="item.role === 'assistant'"
	                        class="icon-item"
	                        data-track-text="删除AI消息"
	                        aria-label="删除AI消息"
	                        @click="deleteMessage(item, messageList[index - 1])"
                        title="删除"
                      >
                        <i class="el-icon-customerarchivesrecycleBin"></i>
                      </span>
	                      <span
	                        class="icon-item"
	                        title="复制"
	                        data-track-text="复制AI消息"
	                        aria-label="复制AI消息"
	                        @click="copyMessage(item)"
                      >
                        <i class="el-icon-fuzhi1"></i>
                      </span>
                      <span
	                        v-if="item.role === 'assistant'"
	                        class="icon-item"
	                        data-track-text="重新生成AI消息"
	                        aria-label="重新生成AI消息"
	                        @click="refreshMessage(messageList[index - 1])"
                        title="重新生成"
                      >
                        <i class="el-icon-zhongxinfenxi"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="chat-default" v-if="isDefaultChat">
            <div
              class="card-item"
              :class="[currentAssistant.tag === item.tag ? 'select-item' : '']"
	              v-for="item in defaultCardList"
	              :key="item.tag"
	              :data-track-text="`选择AI助手${item.title}`"
	              :aria-label="`选择AI助手${item.title}`"
	              @click="selectAssistant(item)"
            >
              <div class="title">
                {{ item.title }}
                <span class="close" data-track-text="删除默认助手" aria-label="删除默认助手" @click.stop="deleteAssistant">
                  <i class="el-icon-close"></i>
                </span>
              </div>
              <div class="desc">
                {{ item.description }}
                <span class="check">
                  <i class="el-icon-check"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="chat-tool">
          <div
            class="origin-lang lang-item"
            @click="showLangPanel('originLang')"
          >
            {{ originLang.label }}
            <img
              referrerpolicy="no-referrer"
              src="../../assets/v2/img/trans/operate.png"
            />
          </div>
          <img
            @click="switchLang"
            class="switch-lang"
            data-track-text="切换AI翻译语种"
            aria-label="切换AI翻译语种"
            referrerpolicy="no-referrer"
            src="../../assets/v2/img/trans/transform.png"
          />
          <div
            class="target-lang lang-item"
            @click="showLangPanel('targetLang')"
          >
            {{ targetLang.label }}
            <img
              referrerpolicy="no-referrer"
              src="../../assets/v2/img/trans/operate.png"
            />
          </div>
          <el-select
            v-model="aiMode.model"
            style="width: 120px"
            size="mini"
            filterable
            placeholder="AI翻译"
          >
            <el-option
              v-for="it in aiModelList"
              :key="it.name"
              :label="it.name"
              :value="it.model"
            ></el-option>
          </el-select>
          <div class="tool-item">AI翻译</div>
          <div class="tool-item">句子润色</div>
          <div class="tool-item">精准提炼</div>
          <div class="tool-item">阅读助手</div>
        </div> -->
        <div class="chat-editor">
          <div class="chat-tool">
            <div
              class="set-lang"
              v-if="isDefaultChat || (currentAssistant.tag || '').includes('trans_')"
            >
              <div class="origin-lang">{{ originLang.label }}</div>
              <img
                @click="switchLang"
                class="switch-lang"
                data-track-text="切换AI翻译语种"
                aria-label="切换AI翻译语种"
                referrerpolicy="no-referrer"
                src="../../assets/v2/img/trans/transform.png"
              />
              <div class="target-lang">{{ targetLang.label }}</div>
            </div>
            <div class="divider" v-if="isDefaultChat"></div>
            <el-select
              v-if="isDefaultChat"
              v-model="aiMode.model"
              class="select-mode"
              size="mini"
              filterable
              placeholder="AI翻译"
            >
              <el-option
                v-for="it in aiModelList"
                :key="it.name"
                :label="it.name"
                :value="it.model"
              ></el-option>
            </el-select>
          </div>
          <el-input
            rows="4"
            resize="none"
            class="editor-message"
            type="textarea"
            placeholder="请输入要翻译的文字……"
            v-model="editorMess"
            maxlength="5000"
            @focus="requestAuthentication"
            @keydown.enter="sendMessage"
          >
          </el-input>
          <i
            class="el-icon-paperclip upload-file"
            data-track-text="上传AI附件"
            aria-label="上传AI附件"
            @click="gotoUrl"
            v-if="isDefaultChat"
          ></i>
          <div class="divider" v-if="isDefaultChat"></div>
          <div
            class="send-message"
            data-track-text="发送AI消息"
            aria-label="发送AI消息"
            :class="[isTalking || !editorMess ? '' : 'active']"
            @click="sendMessage"
          >
            <span class="send"></span>
          </div>
        </div>
      </div>

      <div class="ai-history" :class="{ 'mobile-open': isMobileHistoryOpen }">
	        <button
	          type="button"
	          class="mobile-history-close"
	          data-track-text="关闭AI历史记录"
	          aria-label="关闭历史记录"
	          @click="closeMobileHistory"
	        >
	          <i class="el-icon-close"></i>
	        </button>
	        <div class="new-chat" data-track-text="开启新AI对话" aria-label="开启新AI对话" @click="setDefaultChat">
          <span class="icon"></span>
          开启新对话
        </div>
        <div class="divider"></div>
        <div class="history-container">
          <div class="history-title"><span class="circle"></span>历史记录</div>
          <div class="history-list">
            <el-scrollbar class="history-scrollbar">
              <div
	                class="history-item"
	                v-for="item in historyList"
	                :key="item.id"
	                data-track-text="打开AI历史记录"
	                aria-label="打开AI历史记录"
	                @click="getHistoryMessage(item)"
              >
                <span class="session-text" :title="item.title">{{
                  item.title
                }}</span>
                <span class="delete-bg">
                  <!-- <span class="icon" @click.stop="showConfirm(item)">删除</span> -->
                  <i class="el-icon-delete" data-track-text="删除AI会话" aria-label="删除AI会话" @click.stop="showConfirm(item)"></i>
                </span>
              </div>
              <div v-if="historyList.length === 0" style="text-align: center">
                暂无记录
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <LangPanel
        v-if="isShowLangPanel"
        :val="''"
        :terminology="'暂不使用术语'"
        @custom-event="changeLang"
      />
    </div>
    <PackagePop ref="packagePop" />
  </div>
</template>
<script>
import LangPanel from "../../components/lang_panel/LangPanel";
import AiEntry from "./AiEntry";
import languages from "../../../language.json";
import MarkdownIt from "markdown-it/dist/markdown-it";
import Loding from "./Loding.vue";
import PackagePop from "./PackagePop";
import { readChatStream, selectChatModel } from "../../utils/chatStream";
const markdownRender = new MarkdownIt({
  html: false, // 模型及历史回答中的原生 HTML 必须作为文本显示
});

export default {
  // 组件名称
  name: "AiChat",
  components: {
    AiEntry,
    LangPanel,
    Loding,
    PackagePop,
  },
  props: {
    userInfo: {
      type: String,
      default: "",
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    aiModelList: {
      type: Array,
      default: () => [],
    },
  },
  // 变量声明
  data() {
    return {
      editorMess: "",
      assistantList: [],
      currentAssistant: {},
      historyList: [],
      aiMode: {
        model: "SPARK",
        name: "星火大模型",
      },
      whichLang: "",
      originLang: {
        label: "中文（简体）",
        value: "zh",
      },
      targetLang: {
        label: "英语",
        value: "en",
      },
      isShowLangPanel: false,
      messageList: [
        {
          role: "assistant",
          content: "你好，我是微思AI翻译助手，快来试试吧!",
        },
      ],
      markdownRender,
      chatNumber: "",
      conversationId: "",
      isTalking: false,
      activeRequest: null,
      historyRequestId: 0,
      currentMessageIndex: 0,
      isMobileHistoryOpen: false,
    };
  },
  computed: {
    isDefaultChat() {
      return this.messageList.length <= 1;
    },
    defaultCardList() {
      return this.assistantList.filter((item) => item.tag !== "trans_default");
    },
  },
  watch: {
    aiModelList: {
      immediate: true,
      handler(models) {
        if (!this.isTalking) this.aiMode = { ...selectChatModel(models, this.aiMode) };
      },
    },
    messageList: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      },
      deep: true, // 深度监听，以便能够检测到数组内部对象的变化
    },
  },
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  mounted() {
    this.getHistory();
    this.getAssistant();
  },
  beforeDestroy() {
    this.cancelGeneration();
  },
  // 方法
  methods: {
    openMobileHistory() {
      this.isMobileHistoryOpen = true;
    },
    closeMobileHistory() {
      this.isMobileHistoryOpen = false;
    },
    requestAuthentication() {
      if (this.isAuthenticated) {
        return true;
      }
      this.$emit("getUserStatus");
      return false;
    },
    selectMessage(index) {
      setTimeout(() => {
        this.currentMessageIndex = index;
      }, 100);
    },
    showConfirm(item) {
      this.$confirm("删除后无法恢复，是否继续删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http
            .delete(`chatApi/v1/chat/${item.chatNumber}`)
            .then((res) => {
              this.$message.success("删除成功");
              this.getHistory();
              this.setDefaultChat();
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    deleteMessage(item, question) {
      this.$confirm("删除后无法恢复，是否继续删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http.delete(`chatApi/v1/chat/message/${question.messageId}`);
          this.$http
            .delete(`chatApi/v1/chat/message/${item.messageId}`)
            .then((res) => {
              this.$message.success("删除成功");
              this.messageList = this.messageList.filter(
                (message) =>
                  message.messageId !== item.messageId &&
                  message.messageId !== question.messageId
              );
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    gotoUrl() {
      this.$emit("gotoPath", "doc");
    },
    copyMessage(item) {
      this.$copyText(item.content);
      this.$message.success("复制成功");
    },
    refreshMessage(item) {
      this.editorMess = item.content;
      this.sendMessage();
    },
    cancelGeneration() {
      if (this.activeRequest) this.activeRequest.controller.abort();
      this.activeRequest = null;
      this.isTalking = false;
    },
    chatSend(conversationId, signal) {
      return fetch(
        `/chatApi/v1/chat/completions?conversationId=${encodeURIComponent(conversationId)}`,
        { method: "get", signal, headers: { authorization: localStorage.getItem("token") } }
      );
    },
    async sendMessage() {
      if (!this.requestAuthentication() || this.isTalking || !this.editorMess.trim()) return;
      if (!this.currentAssistant.tag || !this.aiMode.model) {
        this.$message.error("助手或模型尚未加载，请稍后重试");
        return;
      }
      const request = { controller: new AbortController() };
      this.activeRequest = request;
      this.isTalking = true;
      const prompt = this.editorMess;
      const model = this.aiMode.model;
      const assistant = { ...this.currentAssistant };
      const from = this.originLang.value;
      const to = this.targetLang.value;
      let answer;
      try {
        if (!this.chatNumber) {
          const created = (await this.$http.post("/chatApi/v1/chat/createChat", {
            model, assistantId: assistant.id, prompt,
          })).data;
          if (this.activeRequest !== request) return;
          if (created.code !== 200 || !created.data || !created.data.chatNumber) {
            throw new Error(created.msg || "创建会话失败，请重试");
          }
          this.chatNumber = created.data.chatNumber;
        }
        const resData = (await this.$http.post("/chatApi/v1/chat/message", {
          model, prompt, chatNumber: this.chatNumber, from, to,
          assistantTag: assistant.tag, assistantTypeTag: "text_trans",
        })).data;
        if (this.activeRequest !== request) return;
        if (resData.code !== 200 || !resData.data) {
          if (resData.code === 600) this.$refs.packagePop.open();
          throw new Error(resData.msg || "发送失败，请重试");
        }
        this.conversationId = resData.data;
        answer = { role: "assistant", content: "" };
        this.messageList.push({ role: "user", content: prompt }, answer);
        if (this.editorMess === prompt) this.editorMess = "";
        const response = await this.chatSend(resData.data, request.controller.signal);
        if (this.activeRequest !== request) return;
        await readChatStream(response, (data) => {
          if (this.activeRequest === request) answer.content = data.content;
        });
        if (this.activeRequest === request) this.getHistory();
      } catch (error) {
        if (this.activeRequest === request && error.name !== "AbortError") {
          const message = error.message || "请求失败，请重试";
          if (answer) answer.content = answer.content ? `${answer.content}\n\n[生成未完成：${message}]` : message;
          if (!this.editorMess) this.editorMess = prompt;
          this.$message.error(message);
        }
      } finally {
        if (this.activeRequest === request) {
          this.activeRequest = null;
          this.isTalking = false;
        }
      }
    },
    scrollToBottom() {
      if (!this.$refs.answerScrollbarRef || !this.$refs.chatListDom) return;
      this.$refs.answerScrollbarRef.wrap.scrollTop =
        this.$refs.chatListDom.scrollHeight;
    },
    setDefaultChat() {
      this.cancelGeneration();
      this.historyRequestId++;
      this.chatNumber = "";
      this.conversationId = "";
      this.closeMobileHistory();
      this.messageList = [
        {
          role: "assistant",
          content: "你好，我是微思AI翻译助手，快来试试吧!",
        },
      ];
      this.currentAssistant = this.assistantList.find(
        (item) => item.tag === "trans_default"
      ) || {};
      this.isTalking = false;
    },
    createChat() {
      return this.$http
        .post("/chatApi/v1/chat/createChat", {
          model: this.aiMode.model,
          assistantId: this.currentAssistant.id,
          prompt: this.editorMess,
        })
        .then((res) => {
          this.chatNumber = res.data.data.chatNumber;
        });
    },
    getHistory() {
      this.$http.get("/chatApi/v1/chat/history").then((res) => {
        this.historyList = res.data.data || [];
      });
    },
    getHistoryMessage(item) {
      this.cancelGeneration();
      const historyRequestId = ++this.historyRequestId;
      this.closeMobileHistory();
      this.chatNumber = item.chatNumber;
      this.currentAssistant = this.assistantList.find(
        (assistant) => assistant.id === item.assistantId
      ) || {};
      this.$http
        .get("/chatApi/v1/chat/message", {
          params: {
            chatNumber: item.chatNumber,
          },
        })
        .then((res) => {
          if (historyRequestId !== this.historyRequestId) return;
          this.messageList = res.data.data || [];
          this.messageList.sort((a, b) => a.id - b.id);
          this.messageList.unshift({
            role: "assistant",
            content: "你好，我是微思AI翻译助手，快来试试吧!",
          });
        });
    },
    deleteAssistant() {
      this.currentAssistant = this.assistantList.find(item => item.tag === "trans_default") || {};
    },
    selectAssistant(assistant) {
      this.currentAssistant = this.assistantList.find(
        (item) => item.tag === assistant.tag
      );
    },
    getAssistant() {
      this.$http
        .get("/chatApi/app/api/assistant", {
          params: {
            typeId: 13,
          },
        })
        .then((res) => {
          this.assistantList = res.data.data;
          this.currentAssistant = this.assistantList.find(
            (item) => item.tag === "trans_default"
          ) || {};
        });
    },
    changeLang(val) {
      this[this.whichLang] = languages.find((item) => item.value === val);
      this.isShowLangPanel = false;
    },
    switchLang() {
      const cacheLang = this.originLang;
      this.originLang = this.targetLang;
      this.targetLang = cacheLang;
    },
    showLangPanel(val) {
      this.whichLang = val;
      this.isShowLangPanel = true;
    },
  },
};
</script>
<style lang="less" scoped>
.ai-chat {
  width: 100%;
  height: calc(100% + 30px);
  margin-top: -50px;
  .chat-container {
    display: flex;
    width: 100%;
    height: 100%;
    .chat-box {
      flex: 1;
      .chat-list {
        overflow: auto;
        height: calc(100% - 260px);
        width: 100%;
        .chat-default {
          display: flex;
          padding: 20px 90px;
          gap: 0 20px;
          cursor: pointer;
          .card-item {
            flex: 1;
            padding: 18px 20px;
            border-radius: 10px;
            border: 1px solid var(--border);
            position: relative;
            overflow: hidden;
            &.select-item {
              border: 1px solid var(--primary);
              background: var(--primary-alpha-05);
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
              .close {
                color: var(--muted-foreground);
              }
              .title {
                color: var(--foreground);
              }
              .desc {
                color: var(--muted-foreground);
              }
            }
            .title {
              font-weight: bold;
              color: var(--muted-foreground);
              .close {
                color: var(--muted-foreground);
                cursor: pointer;
                position: absolute;
                top: 10px;
                right: 10px;
              }
            }
            .desc {
              font-size: 14px;
              color: var(--muted-foreground);
              margin-top: 12px;
              .check {
                width: 46px;
                height: 40px;
                background: var(--primary);
                border-radius: 10px;
                position: absolute;
                bottom: -20px;
                right: -20px;
                i {
                  margin-left: 5px;
                  color: #fff;
                }
              }
            }
          }
        }
        .answer-container {
          padding: 20px 0;
          // height: calc(100% - 40px);
          .answer-scrollbar {
            height: 100%;
            .right {
              text-align: right;
            }
            .left {
              text-align: left;
            }
          }
          .ai-avatar,
          .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
          .ai-avatar {
            background: url(../../assets/chat/talk.png) center no-repeat;
            background-size: contain;
          }
          .user-avatar {
            background: var(--primary-alpha-14);
            .user {
              display: inline-block;
              width: 100%;
              height: 100%;
              background: url(../../assets/chat/avatar.png) center no-repeat;
              background-size: 60%;
              filter: hue-rotate(120deg) saturate(1.5);
            }
          }
          .answer-item {
            display: inline-block;
            position: relative;
            margin-bottom: 40px;
            margin-left: 60px;
            margin-right: 60px;
            .action {
              display: none;
              position: absolute;
              bottom: -32px;
              left: 0;
              padding: 20px 20px 0 20px;
              .icon-item {
                cursor: pointer;
                padding: 6px;
                &:hover {
                  background: #f5f5f5;
                  border-radius: 2px;
                }
              }
            }
            &.select {
              .action {
                display: inline-block;
                width: max-content;
              }
            }
            // &:hover {
            //   .action {
            //     display: inline-block;
            //   }
            // }
          }
          .answer-item.assistant {
            border-radius: 10px;
            background-color: #f5f5f5;
            padding-left: 20px;
            padding-right: 20px;
          }
          .answer-item.assistant:hover {
            background-color: rgb(241 245 249);
          }
          .answer-item .user-answer {
            border-radius: 10px;
            background-color: var(--primary-alpha-08);
            padding: 16px 20px;
            text-align: left;
          }
          .answer-item .ai-avatar {
            position: absolute;
            left: -50px;
            top: 6px;
          }
          .answer-item .user-avatar {
            position: absolute;
            right: -50px;
            top: 6px;
          }
          .user {
            padding-top: 0;
            .action {
              right: 0;
            }
          }
        }
      }
      .chat-editor {
        height: 260px;
        background: var(--bg-subtle);
        border-radius: 24px;
        border: 1px solid var(--border);
        margin: 0 28px;
        position: relative;
        .chat-tool {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: var(--muted-foreground);
          line-height: 24px;
          padding: 8px 20px;
          .set-lang {
            display: flex;
            align-items: center;
          }
          .switch-lang {
            cursor: pointer;
            margin: 0 16px 0 10px;
          }
          .divider {
            width: 1px;
            height: 12px;
            background: rgba(115, 115, 115, 0.36);
            margin: 0 0 0 20px;
          }
          .select-mode {
            width: 120px;
            /deep/.el-input__inner {
              color: var(--primary);
              border: none;
              background: transparent;
            }
            /deep/.el-select__caret {
              color: var(--primary);
            }
          }
        }
        .editor-message {
          // padding-top: 10px;
          background: var(--bg-subtle);
          height: calc(100% - 100px);
          // border-radius: 24px;

          /deep/.el-textarea__inner {
            height: 100%;
            border: none;
            border-radius: 24px;
            background: var(--bg-subtle);
            font-size: 18px;
          }
        }
        .upload-file {
          font-size: 24px;
          color: #474747;
          cursor: pointer;
          position: absolute;
          right: 70px;
          bottom: 20px;
        }
        .divider {
          width: 1px;
          height: 22px;
          background: rgba(115, 115, 115, 0.36);
          position: absolute;
          right: 60px;
          bottom: 20px;
        }
        .send-message {
          width: 35px;
          height: 35px;
          background: var(--muted-fg-light);
          border-radius: 50%;
          position: absolute;
          right: 15px;
          bottom: 15px;
          cursor: pointer;
          &.active {
            background: #10b981;
          }
          .send {
            width: 20px;
            height: 18px;
            display: inline-block;
            background: url(../../assets/chat/send.png) center no-repeat;
            background-size: contain;
            margin: 8px 0 0 6px;
          }
        }
      }
    }
    .ai-history {
      width: 280px;
      z-index: 9;
      .new-chat {
        margin-top: 32px;
        width: 140px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        background: #f8f9ff;
        border-radius: 6px;
        border: 1px solid #d5e0e4;
        cursor: pointer;
        margin-left: 18px;
        .icon {
          display: inline-block;
          width: 18px;
          height: 18px;
          background: url(../../assets/chat/new-chat.png) center no-repeat;
          background-size: contain;
          vertical-align: sub;
        }
      }
      .divider {
        width: calc(100% - 35px);
        height: 1px;
        background-color: var(--border-light);
        margin: 14px 0 18px 18px;
      }
      .history-container {
        overflow: auto;
        height: calc(100% - 66px);
        font-size: 14px;
        margin-left: 18px;
        .history-title {
          font-size: 16px;
          font-weight: bold;
          color: var(--foreground-secondary);
          .circle {
            width: 5px;
            height: 5px;
            display: inline-block;
            background: var(--primary);
            border-radius: 50%;
            margin-right: 18px;
            vertical-align: middle;
          }
        }
        .history-list {
          border-left: 3px solid var(--border-light);
          margin-top: 15px;
          padding-top: 15px;
          height: calc(100% - 80px);
          overflow: hidden;
          .history-scrollbar {
            height: 100%;
            .history-item {
              padding-left: 20px;
              line-height: 34px;
              height: 34px;
              cursor: pointer;
              &:hover {
                background: #f1f2f3;
                color: var(--primary);
                .delete-bg {
                  display: inline-block;
                  color: var(--muted-foreground);
                }
              }
              .session-text {
                display: inline-block;
                overflow: hidden; /* 隐藏溢出内容 */
                white-space: nowrap; /* 禁止文本换行 */
                text-overflow: ellipsis; /* 显示省略符号 */
                width: calc(100% - 30px); /* 需要指定宽度（或max-width）*/
              }
              .delete-bg {
                vertical-align: top;
                display: none;
              }
            }
          }
        }
      }
    }
  }
}

.mobile-chat-nav,
.mobile-history-mask,
.mobile-history-close {
  display: none;
}

/* AI 翻译移动工作台：全部卡片纵向展示，历史记录通过侧滑面板访问。 */
@media (max-width: 768px) {
  .ai-chat {
    width: 100%;
    height: 100%;
    min-width: 0;
    margin-top: 0;
    overflow: hidden;

    .chat-container {
      position: relative;
      width: 100%;
      height: 100%;
      min-width: 0;
      min-height: 0;
      overflow: hidden;

      .mobile-history-mask {
        position: absolute;
        z-index: 20;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        background: rgba(25, 39, 55, 0.28);
      }

      .chat-box {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        width: 100%;
        min-width: 0;
        min-height: 0;
        padding: 0;

        .mobile-chat-nav {
          display: flex;
          flex: 0 0 44px;
          align-items: center;
          justify-content: flex-end;
          gap: 8px;
          width: 100%;
          height: 44px;
          padding: 6px 12px;
          border-bottom: 1px solid var(--border-light);
          background: #ffffff;
          box-sizing: border-box;

          .mobile-chat-action {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
            height: 32px;
            padding: 0 12px;
            border: 1px solid #d9e3ec;
            border-radius: 6px;
            outline: none;
            background: #f8fbff;
            color: var(--primary);
            font-size: 13px;
            font-family: "Microsoft YaHei", sans-serif;
            line-height: 30px;
            cursor: pointer;
          }
        }

        .chat-list {
          flex: 1 1 auto;
          width: 100%;
          height: auto;
          min-width: 0;
          min-height: 0;
          overflow-x: hidden;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;

          .chat-default {
            display: grid;
            grid-template-columns: minmax(0, 1fr);
            align-items: stretch;
            gap: 8px;
            width: 100%;
            padding: 8px 12px 12px;
            overflow: visible;
            box-sizing: border-box;

            .card-item {
              width: 100%;
              min-width: 0;
              min-height: 0;
              padding: 10px 14px;
              box-sizing: border-box;

              .title,
              .desc {
                overflow-wrap: anywhere;
                word-break: break-word;
              }

              .desc {
                margin-top: 4px;
                padding-right: 18px;
                line-height: 18px;
              }
            }
          }

          .answer-container {
            padding: 14px 0 4px;

            .ai-avatar,
            .user-avatar {
              width: 32px;
              height: 32px;
            }

            .answer-item {
              max-width: calc(100% - 60px);
              margin-right: 10px;
              margin-bottom: 28px;
              margin-left: 46px;
              box-sizing: border-box;
              overflow-wrap: anywhere;
              word-break: break-word;
            }

            .right .answer-item {
              margin-right: 46px;
              margin-left: 10px;
            }

            .answer-item.assistant {
              padding-right: 14px;
              padding-left: 14px;
            }

            .answer-item .user-answer {
              padding: 12px 14px;
              overflow-wrap: anywhere;
              word-break: break-word;
            }

            .answer-item .ai-avatar {
              left: -40px;
            }

            .answer-item .user-avatar {
              right: -40px;
            }

            .prose {
              max-width: 100%;
              overflow-wrap: anywhere;
              word-break: break-word;
            }
          }
        }

        .chat-editor {
          flex: 0 0 180px;
          width: calc(100% - 24px);
          height: 180px;
          min-width: 0;
          margin: 0 12px 14px;
          border-radius: 16px;
          box-sizing: border-box;

          .chat-tool {
            display: flex;
            flex-wrap: nowrap;
            width: 100%;
            min-width: 0;
            padding: 8px 12px;
            line-height: 22px;
            box-sizing: border-box;

            .set-lang {
              display: flex;
              flex: 1 1 auto;
              min-width: 0;
              white-space: nowrap;
            }

            .origin-lang,
            .target-lang {
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .switch-lang {
              flex: 0 0 auto;
              margin: 0 8px;
            }

            > .divider {
              position: static;
              flex: 0 0 1px;
              height: 12px;
              margin: 0 4px;
            }

            .select-mode {
              flex: 0 1 108px;
              width: 108px;
              min-width: 82px;

              /deep/ .el-input__inner {
                padding-right: 22px;
                padding-left: 6px;
              }
            }
          }

          .editor-message {
            width: 100%;
            min-width: 0;
            height: calc(100% - 92px);

            /deep/ .el-textarea__inner {
              padding: 10px 12px;
              border-radius: 16px;
              font-size: 16px;
              line-height: 24px;
            }
          }

          .upload-file {
            right: 64px;
            bottom: 17px;
            font-size: 22px;
          }

          > .divider {
            right: 55px;
            bottom: 17px;
          }

          .send-message {
            right: 12px;
            bottom: 11px;
          }
        }
      }

      /* 手机端把桌面固定侧栏改成覆盖式抽屉，保留完整历史功能。 */
      .ai-history {
        position: absolute;
        z-index: 21;
        top: 0;
        right: 0;
        bottom: 0;
        display: block;
        width: 86%;
        max-width: 320px;
        height: 100%;
        overflow: hidden;
        background: #ffffff;
        box-shadow: -10px 0 30px rgba(20, 45, 70, 0.16);
        box-sizing: border-box;
        visibility: hidden;
        pointer-events: none;
        transform: translateX(100%);
        transition: transform 0.2s ease, visibility 0s linear 0.2s;

        &.mobile-open {
          visibility: visible;
          pointer-events: auto;
          transform: translateX(0);
          transition: transform 0.2s ease, visibility 0s linear;
        }

        .mobile-history-close {
          position: absolute;
          z-index: 2;
          top: 14px;
          right: 14px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          padding: 0;
          border: 0;
          border-radius: 6px;
          outline: none;
          background: #f3f6f9;
          color: #607080;
          font-size: 16px;
          cursor: pointer;
        }

        > .new-chat {
          width: calc(100% - 76px);
          margin: 14px 54px 0 16px;
          box-sizing: border-box;
        }

        > .divider {
          width: calc(100% - 32px);
          margin: 12px 16px 14px;
        }

        > .history-container {
          display: flex;
          flex-direction: column;
          height: calc(100% - 76px);
          margin-left: 16px;
          padding-right: 12px;
          overflow: hidden;
          box-sizing: border-box;

          .history-title {
            flex: 0 0 auto;
          }

          .history-list {
            flex: 1 1 auto;
            height: auto;
            min-height: 0;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>
